import UseRegionData from './useRegionData';
import setupGTMServerside from './initializeGTMServerside';

export function setupServersideConfig(data, location) {
  if (typeof data === 'undefined') {
    // it's a never-published Draft page. Default to US region.
    var pageRegion = 'US';
  } else {
    var modelsQueried = Object.values(data?.allBuilderModels);
    var pageData = modelsQueried.find((el) => el !== null);
    pageData = pageData?.content;
    pageRegion = pageData?.data?.region;
  }

  var regionConfig = UseRegionData('harrys', pageRegion); // uses graphQL to pull data from the JSON files in the /data/region/ subdirectory

  regionConfig.country =
    pageRegion && pageRegion.includes('-')
      ? pageRegion.split('-')[0]
      : pageRegion;
  regionConfig.country = regionConfig.country.trim().toUpperCase();

  regionConfig.modelName = 'harrys-marketing-page';

  const { headGTMScript, bodyGTMIframe } = setupGTMServerside(
    regionConfig.tagContainerId
  );
  regionConfig.headGTMScript = headGTMScript; // Added to <head> via <script> in Helmet in marketingPage.jsx
  regionConfig.bodyGTMIframe = bodyGTMIframe; // Added to <body> via <noscript> in Main in Layout/index.jsx

  return { pageData, regionConfig };
}
